import React from "react";
import images from "../../../utilities/images/images";
import {
  formatPrice,
  getBookDiscountPercent,
  hasBookDiscount,
} from "../utils/coursePricing";
import { getExploreBookAnchorId } from "../utils/exploreCoursesScrollRestore";
import { getExploreCardClassName } from "../utils/exploreCardHighlight";
import "./dashboardExploreCard.css";
import "./BooksForYouCard.css";

const BooksForYouCard = ({ book, highlightedAnchorId = null, onBuy, onDetails }) => {
  const finalPrice = book?.discounted_price ?? book?.price;
  const showDiscount = hasBookDiscount(book?.price, book?.discounted_price);
  const discountLabel = getBookDiscountPercent(book?.price, book?.discounted_price);

  const anchorId = book?.p_id ? getExploreBookAnchorId(book.p_id) : undefined;
  const isSelected = Boolean(anchorId && highlightedAnchorId === anchorId);

  return (
    <article
      className={getExploreCardClassName("books-for-you-card", anchorId, highlightedAnchorId)}
      id={anchorId}
      aria-current={isSelected ? "true" : undefined}
    >
      <div className="books-for-you-card__image-wrap">
        <img src={book?.image} alt="" className="books-for-you-card__image" />
        {book?.tag ? (
          <span className="books-for-you-card__tag">{book.tag}</span>
        ) : null}
      </div>

      <h3 className="books-for-you-card__title">{book?.product_name || "—"}</h3>

      <div className="books-for-you-card__price-row">
        <div className="books-for-you-card__prices">
          <strong>{formatPrice(finalPrice)}</strong>
          {showDiscount ? (
            <span className="books-for-you-card__strike">{formatPrice(book.price)}</span>
          ) : null}
        </div>
        {discountLabel ? (
          <span className="books-for-you-card__discount">{discountLabel}</span>
        ) : null}
      </div>

      <div className="books-for-you-card__actions">
        <button type="button" className="books-for-you-card__buy" onClick={onBuy}>
          BUY NOW
        </button>
        <button
          type="button"
          className="books-for-you-card__arrow"
          onClick={onDetails}
          aria-label="View book details"
        >
          <img
            src={images.recommendedDetailArrow}
            alt=""
            aria-hidden="true"
            className="books-for-you-card__arrow-icon"
          />
        </button>
      </div>
    </article>
  );
};

export default BooksForYouCard;
